import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import API from '@/apiRequest';
import PreviousIcon from '@/svg-icons/previous';

const PreviousInspectionSection = ({
  orderId,
  orderType,
  previousInspection,
  canEditPreviousInspection,
  openEditPreviousInspection,
}) => {
  const [url, setUrl] = useState(null);

  const hasInspection = Boolean(previousInspection?.inspection?.id);
  const hasFile = Boolean(previousInspection?.file?.original_name);

  useEffect(() => {
    if (hasFile && orderId) {
      API.get(`/orders/${orderId}/attachments`)
        .then(res => {
          if (res.data?.url) {
            setUrl(res.data.url);
          }
        })
        .catch(err => {
          console.debug('PreviousInspectionSection.useEffect error ', err);
        });
    }
  }, [orderId, hasFile]);

  if (!hasInspection && (!hasFile || !url)) {
    return null;
  }

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center justify-between">
        <div className="flex items-center">
          <PreviousIcon 
            viewBox="0 0 34.016 34.016" 
            className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
          />
          <FormattedMessage id="previous" />
        </div>

        {canEditPreviousInspection && openEditPreviousInspection && (
          <button
            type="button"
            className="bg-transparent border-none cursor-pointer p-0 underline font-bold text-[calc(6px+0.4vw)] text-inherit hover:opacity-80 transition-all disabled:opacity-50"
            onClick={() => openEditPreviousInspection({ orderId, orderType })}
            data-cy="order-details-edit-previous-inspection"
          >
            <FormattedMessage id="orderDetails.editPreviousInspection" defaultMessage="Editar" />
          </button>
        )}
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)] gap-y-[1vw]">
        {hasInspection && (
          <div className="flex flex-col" data-cy="order-details-previous-inspection-name-id">
            <div className="font-bold">
              <FormattedMessage id="inspection" />
            </div>
            <div>
              <Link to={`/orders/${previousInspection.inspection.id}`} className="text-[#007bff] hover:text-[#0056b3] hover:underline">
                {previousInspection.inspection.name}, {previousInspection.inspection.id}
              </Link>
            </div>
          </div>
        )}

        {hasFile && url && (
          <div className="flex flex-col">
            <div className="font-bold">
              <FormattedMessage id="file" />
            </div>
            <div>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                data-cy="order-details-previous-inspection-file-original-name"
                className="text-[#007bff] hover:text-[#0056b3] hover:underline"
              >
                {previousInspection.file.original_name}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

PreviousInspectionSection.propTypes = {
  previousInspection: PropTypes.shape({
    inspection: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    }),
    file: PropTypes.shape({
      original_name: PropTypes.string,
    }),
  }),
  canEditPreviousInspection: PropTypes.bool,
  openEditPreviousInspection: PropTypes.func,
  orderId: PropTypes.string,
  orderType: PropTypes.string,
};

PreviousInspectionSection.defaultProps = {
  canEditPreviousInspection: false,
  openEditPreviousInspection: null,
  previousInspection: {},
  orderId: null,
  orderType: null,
};

export default PreviousInspectionSection;